import { useMemo } from 'react'
import { useController } from 'react-hook-form'

import { FormFieldWrapper } from '@/components/ui'

import { FormFieldRadioChildGroupProps } from './type'
import { InputRadioChildGroup } from '../../input/InputRadioChildGroup'

export const FormFieldRadioChildGroup = ({
  options,
  disabled,
  direction,
  gap,
  label,
  showLabel,
  formName,
  control,
  error,
  showError,
  optionChildren,
  childDirection,
  childGap,
}: FormFieldRadioChildGroupProps) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({ name: formName, control })

  const selectedOption = useMemo(
    () => options.find((option) => option.value === value),
    [options, value]
  )

  const handleBlur = () => {
    onBlur && onBlur()
  }

  return (
    <FormFieldWrapper
      label={label}
      error={error}
      showLabel={showLabel}
      showError={showError}
    >
      <InputRadioChildGroup
        options={options}
        disabled={disabled}
        selected={selectedOption ? selectedOption.value : null}
        direction={direction}
        gap={gap}
        handleChange={(value) => onChange(value)}
        handleBlur={handleBlur}
        optionChildren={optionChildren}
        childDirection={childDirection}
        childGap={childGap}
      />
    </FormFieldWrapper>
  )
}
